// @ts-nocheck
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FileUploader } from 'react-drag-drop-files';
import FormikControl from 'src/components/Formik/FormikControl';
import { InsuranceUpload } from 'src/components/InsuranceUpload';
import SMS from './SMS';

type Props = {
  open: boolean;
  onClose: () => void;
  onSend: () => void;
  onDone?: () => void;
  onStartPolling?: () => void; 
  selectedInsurance: any
};

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 3,
  width: '90%',
  maxWidth: '30vw',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center' 
};

const SMSModal = ({ open, onClose, onSend, onDone, onStartPolling, selectedInsurance }: Props) => {
  const [localCard, setLocalCard] = useState<any>(null);

  useEffect(() => {
    if (!open) {
      setLocalCard(null);
    } else if (selectedInsurance) {
      setLocalCard(selectedInsurance);
    }
  }, [selectedInsurance, open]);
    

  useEffect(() => {
    if (open && selectedInsurance?._id && onStartPolling) {
      onStartPolling();
    }
  }, [open, selectedInsurance?._id]);     

  const handleClickSend = async () => {
    const newCard = await onSend();
    if (newCard && newCard._id) {
      setLocalCard(newCard);
    } else {
      toast.error("Card creation failed. Please try again.");
  };    }


  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <IconButton sx={{ position: 'absolute', top: '8px', right: '8px' }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <Typography sx={{ textAlign: 'center', mb: 1 }} variant="h6">
            Insurance Card Mobile Upload
          </Typography>

          {!localCard || !localCard._id ? (
            <Button variant="contained" onClick={handleClickSend}>
              Create Card
            </Button>
          ) : (
            <InsuranceUpload
              openedFromModal={true}
              onSend={() => Promise.resolve()}
              selectedInsurance={localCard}
              onExitEditMode={onDone}
              onStartPolling={onStartPolling}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default SMSModal;